import { Component, Input } from '@angular/core';

@Component({
  selector: 'adc-loader',
  templateUrl: './adc-loader.component.html',
  styleUrls: ['./adc-loader.component.scss'],
  standalone: false
})
export class AdcLoaderComponent {
  @Input('type') type: string = 'style1';
  @Input('progressVal') progressVal!: number;
}
